(() => {
  const ready = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  ready(() => {
    const root = document.documentElement;
    const measurementSelector = '.shopify-section-group-header-group, .section-header, sticky-header, .bpc-market-bar, [data-bpc-collection-rail-shell]';
    let frameId = 0;
    let lastStackHeight = -1;
    let lastRailHeight = -1;
    const observedTargets = new WeakSet();
    const resizeObserver = 'ResizeObserver' in window ? new ResizeObserver(() => scheduleMeasurements()) : null;
    const attributeObserver = new MutationObserver(() => scheduleMeasurements());

    const replaceHomepageLogoHeading = () => {
      if (!document.querySelector('.bpc-v7')) return;
      const heading = document.querySelector('h1.header__heading');
      if (!heading) return;

      const replacement = document.createElement('div');
      [...heading.attributes].forEach((attribute) => {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      while (heading.firstChild) replacement.appendChild(heading.firstChild);
      heading.replaceWith(replacement);
    };

    const getVisibleHeaderBottom = () => {
      const candidates = [
        ...document.querySelectorAll(
          '.shopify-section-group-header-group, .section-header, sticky-header, .bpc-market-bar'
        )
      ];
      let bottom = 0;

      candidates.forEach((element) => {
        const style = window.getComputedStyle(element);
        const rect = element.getBoundingClientRect();
        const visible =
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          rect.height > 0 &&
          rect.bottom > 0;
        const stickyLike =
          style.position === 'sticky' ||
          style.position === 'fixed' ||
          element.classList.contains('shopify-section-header-sticky') ||
          rect.top <= 1;

        if (visible && stickyLike && rect.top < window.innerHeight) {
          bottom = Math.max(bottom, Math.min(rect.bottom, window.innerHeight));
        }
      });

      return Math.max(0, Math.round(bottom));
    };

    const updateMeasurements = () => {
      frameId = 0;
      const stackHeight = getVisibleHeaderBottom();
      if (stackHeight !== lastStackHeight) {
        lastStackHeight = stackHeight;
        root.style.setProperty('--bpc-ui-stack-height', `${stackHeight}px`);
      }

      const rail = document.querySelector('[data-bpc-collection-rail-shell]');
      const railHeight = rail ? Math.max(0, Math.round(rail.getBoundingClientRect().height)) : 0;
      if (railHeight !== lastRailHeight) {
        lastRailHeight = railHeight;
        root.style.setProperty('--bpc-collection-rail-height', `${railHeight}px`);
      }
    };

    const scheduleMeasurements = () => {
      if (frameId) return;
      frameId = window.requestAnimationFrame(updateMeasurements);
    };

    const observeMeasurementTargets = () => {
      document.querySelectorAll(measurementSelector).forEach((element) => {
        if (observedTargets.has(element)) return;
        observedTargets.add(element);
        resizeObserver?.observe(element);
        attributeObserver.observe(element, {
          attributes: true,
          attributeFilter: ['class', 'style', 'hidden', 'aria-hidden']
        });
      });
    };

    replaceHomepageLogoHeading();

    document.querySelectorAll('[data-bpc-rail-control]').forEach((button) => {
      button.addEventListener('click', () => {
        const targetId = button.getAttribute('data-bpc-rail-control');
        const direction = button.getAttribute('data-direction') === 'prev' ? -1 : 1;
        const rail = document.getElementById(targetId);
        if (!rail) return;

        rail.scrollBy({
          left: direction * Math.max(220, Math.round(rail.clientWidth * .78)),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      });
    });

    observeMeasurementTargets();
    window.addEventListener('resize', scheduleMeasurements, { passive: true });
    window.addEventListener('orientationchange', scheduleMeasurements, { passive: true });
    document.addEventListener('shopify:section:load', () => {
      observeMeasurementTargets();
      scheduleMeasurements();
    });

    scheduleMeasurements();
  });
})();
(() => {
  const initializeMarketShortcut = () => {
    const menu = document.querySelector('#menu-drawer .menu-drawer__navigation > .menu-drawer__menu');
    const marketBar = document.querySelector('[data-bpc-market-bar]');
    if (!menu || !marketBar || menu.querySelector('[data-bpc-footer-market-shortcut]')) return;

    const selector = marketBar.querySelector('.bpc-market-bar__selector');
    const selectorSummary = selector?.querySelector(':scope > summary');
    if (!selector || !selectorSummary) return;

    const item = document.createElement('li');
    item.setAttribute('data-bpc-footer-market-shortcut', '');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'menu-drawer__menu-item list-menu__item link link--text focus-inset';
    button.setAttribute('aria-label', 'Choose country, region and currency');
    button.textContent = `Country/region · ${selectorSummary.textContent.replace('⌄', '').replace(/\s+/g, ' ').trim()}`;
    Object.assign(button.style, {
      width: '100%',
      border: '0',
      background: 'transparent',
      textAlign: 'left',
      font: 'inherit',
      cursor: 'pointer'
    });

    item.append(button);
    menu.append(item);

    button.addEventListener('click', () => {
      const drawer = document.getElementById('Details-menu-drawer-container');
      const drawerWasOpen = Boolean(drawer?.open);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (drawerWasOpen) {
        drawer.querySelector(':scope > summary')?.click();
      }

      marketBar.scrollIntoView({
        behavior: reduceMotion ? 'auto' : 'smooth',
        block: 'center'
      });

      window.setTimeout(() => {
        selector.open = true;
        selectorSummary.focus({ preventScroll: true });
      }, drawerWasOpen && !reduceMotion ? 260 : 0);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeMarketShortcut, { once: true });
  } else {
    initializeMarketShortcut();
  }

  document.addEventListener('shopify:section:load', initializeMarketShortcut);
})();
